import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Result from 'componentsV2/Result';
import { SEARCH_POSTER } from 'componentsV2/Poster';
import Styles from './Browse.module.scss';

const Browse = ({
  account,
  fetching,
  fetchingSearch,
  items,
  loadMore,
  next,
  searchProps,
  shouldRender,
  Style,
  type,
}) => {
  if (!shouldRender) return null;
  if (!fetchingSearch && searchProps?.searchCompleted && !items?.length) {
    return (
      <div className={classNames(Styles.notFound)} aria-live="polite">
        <h3 className={classNames(Styles.notFoundTitle)}>We couldn’t find any results.</h3>
        <p className={classNames(Styles.notFoundSubTitle)}>Try a new search</p>
      </div>
    );
  }

  return (
    <>
      <Result
        account={account}
        fetching={fetching}
        items={items}
        loadMore={loadMore}
        next={next}
        searchProps={searchProps}
        posterType={SEARCH_POSTER}
        type={type}
        theme={Style}
      />
    </>
  );
};

Browse.propTypes = {
  account: PropTypes.shape({}),
  fetching: PropTypes.bool,
  fetchingSearch: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  loadMore: PropTypes.func,
  next: PropTypes.string,
  searchProps: PropTypes.shape({}),
  shouldRender: PropTypes.bool,
  Style: PropTypes.shape({}),
  type: PropTypes.string,
};

export default Browse;
